import axiosClient from ".";
class MetaMaskSignInAPI {
  static metamask_signin(data) {
    return axiosClient.post("/metamask_signins.json", data);
  }
}
export default MetaMaskSignInAPI;
